import { Result } from "common";

const BASE_URL =
  process.env.NEXT_PUBLIC_API_URL ?? "https://dev.api.moneyline.com";

  function makeFullUrl(path: string) {
    if (/^https?:\/\//.test(path)) return path;
    return new URL(path, BASE_URL).toString();
  }

type FetchConfig = Omit<RequestInit, "method" | "body" | "headers"> & {
  headers?: HeadersInit;
  next?: { cache?: RequestCache; revalidate?: number };
};

async function request<T>(
  url: string,
  method: string,
  data?: any,
  token?: string | null,
  config: FetchConfig = {}
): Promise<Result<T>> {
  const fullUrl = makeFullUrl(url);
  const headers = new Headers(config.headers);
  headers.set("Content-Type", "application/json");
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const init: RequestInit & { next?: typeof config.next } = {
    method,
    headers,
    ...(data !== undefined ? { body: JSON.stringify(data) } : {}),
    ...config,
    cache: method === "GET" ? "no-store" : config.cache,
    next: {
      cache: method === "GET" ? "no-store" : config.next?.cache,
      revalidate: method === "GET" ? 0 : config.next?.revalidate,
    },
  };
  const res = await fetch(fullUrl, init);
  const json = await res.json().catch(() => ({}));
  console.log("json from request", json);
  return {
    ok: json.ok,
    code: json.code,
    message: json.message,
    data: json.data,
  };
}

const mlClient = {
  get: <T>(url: string, token?: string | null, cfg?: FetchConfig) =>
    request<T>(url, "GET", undefined, token, cfg),
  post: <T>(url: string, data: any, token?: string | null, cfg?: FetchConfig) =>
    request<T>(url, "POST", data, token, cfg),
  put: <T>(url: string, data?: any, token?: string | null, cfg?: FetchConfig) =>
    request<T>(url, "PUT", data, token, cfg),
  delete: <T>(url: string, token?: string | null, cfg?: FetchConfig) =>
    request<T>(url, "DELETE", undefined, token, cfg),
};

export default mlClient;
